import React from "react";
import { Container } from "reactstrap";

const OurPromise = ({ title, subTitle, descriptionText, image, children }) => {
  return (
    <>
      <Container>
        <div className="flex flex-col lg:flex-row justify-between items-start">
          <div className="reveal-up">
            <p className="text-[16px] ">{title}</p>
            <h3 className="text-[28px] font-[600] mb-8 lg:mb-0">{subTitle}</h3>
          </div>
          {descriptionText && (
            <div className="text-right max-w-lg reveal-up">
              <div className="text-[16px] line-clamp-3">{descriptionText}</div>
            </div>
          )}
          {children && children}
        </div>
      </Container>
      <div className="pl-[16px] lg:container overflow-auto text-center mt-5 animate__animated animate__zoomIn">
        <div className="w-[170%] lg:w-full">
          <img
            src={image}
            alt="AFGSL"
            className="block mx-auto w-full lg:w-3/4"
          />
        </div>
      </div>
    </>
  );
};

export default OurPromise;
